module.exports = __webpack_public_path__ + "static/media/line.879bf2ee.svg";